import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  indexCell: {
    borderBottom: 'none',
    width: '40px',
  },
}));
